import { FormattingService } from './../../../../services/formatting.service';
import {
    Component,
    OnInit,
    OnChanges,
    Input,
    Output,
    EventEmitter,
    SimpleChanges,
} from '@angular/core';
import moment from 'moment';

/**
 * This component shows a date and time picker
 */
@Component({
    selector: 'app-datetime-picker',
    templateUrl: './datetime-picker.component.html',
    styleUrls: ['./datetime-picker.component.scss'],
    standalone: false
})
export class DateTimePickerComponent implements OnInit, OnChanges {
    date = '';
    time: string;

    @Input()
        startDateTime: Date | string;

    @Input()
        maxDate: Date | string;

    @Input()
        outputAsString = true;

    @Input()
        labels = ['Datum', 'Tijd'];

    @Input()
        minDate: Date | string;

    @Input()
        disabled = false;

    @Output()
        valueChange = new EventEmitter<Date | string>();



    constructor(private formattingService: FormattingService) {}

    ngOnInit() {
        this.syncFromInput();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['startDateTime']) {
            this.syncFromInput();
        }
    }

    private syncFromInput() {
        const initial = this.startDateTime ? moment(this.startDateTime) : moment();
        const safe = initial.isValid() ? initial : moment();
        this.time = safe.format('HH:mm');
        this.date = safe.format('YYYY-MM-DD');
    }

    timeChanged(time) {
        if (time) {
            this.time = time;
            this.valueChange.emit(this.format());
        }
    }

    dateChanged(date) {
        const parsed = date ? moment(date) : null;
        if (!parsed || !parsed.isValid()) return;
        this.date = parsed.format('YYYY-MM-DD');
        this.valueChange.emit(this.format());
    }

    format(): Date | string {
        const time = moment(this.time, 'HH:mm');
        const datetime = moment(this.date).hour(time.hour()).minute(time.minute());

        if (this.outputAsString) {
            return this.formattingService.getApiDateFromDateObject(datetime.toDate());
        } else {
            return datetime.toDate();
        }
    }
}
